import { render, staticRenderFns } from "./caseDetails.vue?vue&type=template&id=0333e404&scoped=true&"
import script from "./caseDetails.vue?vue&type=script&lang=js&"
export * from "./caseDetails.vue?vue&type=script&lang=js&"
import style0 from "./caseDetails.vue?vue&type=style&index=0&id=0333e404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0333e404",
  null
  
)

export default component.exports